import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from './Routes/PrivateRoute';
import Private from './screens/Private.jsx';
import fallbackImage from './assests/www1.svg';
import fallbackImageFISART from './assests/logo.svg';
import './App.css';

// 1. Carga perezosa (Lazy Imports)
const Land = lazy(() => import("./components/land"));
const Login = lazy(() => import("./screens/Login.jsx"));
const Stats = lazy(() => import("./components/blog.js"));
const StatsTest = lazy(() => import("./components/blog2.js"));
const AddUser = lazy(() => import("./screens/Private copy.jsx"));
const DashBoard = lazy(() => import("./components/Category.jsx"));
const Carrera = lazy(() => import("./components/carreras.js"));
const Cursos = lazy(() => import("./components/Capacitaciones.js"));
const Articulos = lazy(() => import("./components/Capacitaciones copy.js"));
const Museo = lazy(() => import("./components/Capacitaciones copy 2.js"));
const Foro = lazy(() => import("./components/ForoESFA.js"));
const Video = lazy(() => import("./components/Video.js"));
const Tramite = lazy(() => import("./components/Tramite.js"));
const Profile = lazy(() => import("./profile"));
const Theme = lazy(() => import("./components/Theme.js"));
const Test = lazy(() => import("./components/taskUser.js"));
const Curses = lazy(() => import("./components/Curses.js"));
const Tests = lazy(() => import("./components/Tests"));

// Estilos estáticos
const pageStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
  backgroundColor: '#f8f9fa'
};

const imageStyle = {
  width: '160px',
  height: '160px',
  borderRadius: '12px',
  objectFit: 'contain'
};

const isTargetHostname = window.location.hostname === "www.esfapa.edu.pe";

// Componente para la pantalla de carga con indicación visual activa
const Loading = () => (
  <div style={pageStyle}>
    <div className="text-center p-3">
      <img
        style={imageStyle}
        src={isTargetHostname ? fallbackImage : fallbackImageFISART}
        alt="Cargando..."
        className="mb-3 shadow-sm p-2 bg-white rounded"
      />
      <div className="d-flex align-items-center justify-content-center gap-2 mt-2">
        <div className="spinner-border spinner-border-sm text-info" role="status">
          {/* <span className="visually-hidden">Cargando</span> */}
        </div>
        <span className="fw-semibold text-secondary fs-6">Cargando página...</span>
      </div>
    </div>
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      {/* Suspense global que captura el cambio de cualquier ruta lazy */}
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* Rutas Públicas */}
          <Route path="/" element={<Land />} />
          <Route path="/login" element={<Login />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/statest/:tipo/:email" element={<StatsTest />} />
          <Route path="/carpeta" element={<DashBoard />} />
          <Route path="/carreras" element={<Carrera />} />
          <Route path="/cursos" element={<Cursos />} />
          <Route path="/foro" element={<Foro />} />
          <Route path="/tramites" element={<Tramite />} />
          <Route path="/www" element={<Profile />} />
          <Route path="/video/:www" element={<Video />} />
          <Route path="/articulos" element={<Articulos />} />
          <Route path="/museo" element={<Museo />} />

          {/* Rutas Privadas Protegidas */}
          <Route path="/adduser" element={<PrivateRoute><AddUser /></PrivateRoute>} />
          <Route path="/theme/:theme/:curse" element={<PrivateRoute><Theme /></PrivateRoute>} />
          <Route path="/test/:idtheme/:codetheme" element={<PrivateRoute><Test /></PrivateRoute>} />
          <Route path="/curso/:id" element={<PrivateRoute><Curses /></PrivateRoute>} />
          <Route path="/private" element={<PrivateRoute><Private /></PrivateRoute>} />
          <Route path="/test/:idtest" element={<PrivateRoute><Tests /></PrivateRoute>} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}